import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import IntegratedAppsHome from "../views/IntegratedAppsHome";
import IntegratedAppsMauzoCrm from "../views/IntegratedAppsMauzoCrm";
import ViewIntegratedCrmAccount from "../views/ViewIntegratedCrmAccount";

export default function IntegratedApps(props) {

	const appContext = useContext(AppContext);

	const [ view, setView ] = useState(null);

	async function init() {
		//run initializations here
	}

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IntegratedAppsHome/>
		} else if(
			appContext.navSubItem === 'mauzocrm' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <IntegratedAppsMauzoCrm/>
		} else if(
			appContext.navSubItem === 'mauzocrm' &&
			appContext.navExtraItem === 'business' &&
			appContext.navMoreItem
		) {
			return <ViewIntegratedCrmAccount businessUid={appContext.navMoreItem}/>
		} 

		return null;
	}

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		const _view = getView();
		if(_view) {
			setView(_view);
		}
	}, [ appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

	//return desired view
	return view;
}